/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Body_Composition_AnalysisInputs */

const en_service_type_body_composition_analysis = /** @type {(inputs: Service_Type_Body_Composition_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body composition analysis`)
};

const pl_service_type_body_composition_analysis = /** @type {(inputs: Service_Type_Body_Composition_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza składu ciała`)
};

/**
* | output |
* | --- |
* | "Body composition analysis" |
*
* @param {Service_Type_Body_Composition_AnalysisInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_body_composition_analysis = /** @type {((inputs?: Service_Type_Body_Composition_AnalysisInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Body_Composition_AnalysisInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_body_composition_analysis(inputs)
	return en_service_type_body_composition_analysis(inputs)
});